import "./leado-block.scss";